
/* eslint-disable max-lines */
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, HostListener, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';
import { ScreenView, UserStatus, KeyEvent, NullCheck } from '../../constants/global.constant';
import { AllDataType, FieldValueType, RedirectRoute, TooltipContent } from '../../shared/shared.interface';
import { KngCardList, KngCardListState, KngValueListState, KngHeaderObjState, KngGridPager, KngValueObjState, TableButtonAction, ActionOpsList, FieldType, InvoiceCheck, InvoiceStatus, StatusChangeOptionList, SortOrder, EquipmentOrderStatus, ChangeRequestIndicator, SubscriptionType, TelematicsResponse, TelematicsStatus, MyQuoteStatus, CheckboxChangeEvent, OrderClassList, SubscriptionClassList, ActionLabel } from './definitions';
import { KngCardListService, PagerService } from './kng-card-list.service';
import { isRaymond } from '../../constants/environment.constant';

@Component({
	selector: 'kng-card-list',
	templateUrl: './template/kng-card-list.component.html',
	styleUrls: ['./template/kng-card-list.component.scss']
})
export class KngCardListComponent implements KngCardList, OnInit, OnDestroy, OnChanges
{
	private subscriptions: Subscription = new Subscription();
	isRaymond:boolean = false;
	openCard: number[] = [];
	pageNumber: number = 1;
	headerList: KngHeaderObjState[] = [];
	dataList: KngValueObjState[] = [];
	public screenWidth: number;
	showAccordionView: boolean = true;
	accordionIcon: string | undefined = '/arrowDown.svg';
	arrowIconGray: string | undefined = '/arrowLeft.svg';
	arrowIconOrange: string | undefined = '/arrowRightOrange.svg';
	indicatorFlag: boolean = false;
	isTelematicsResponse: TelematicsResponse = {
		connected: false,
		notConnected: false,
		error: false
	};
	// eslint-disable-next-line @typescript-eslint/naming-convention
	View = ScreenView;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	FieldType = FieldType;
	invoiceCheck = InvoiceCheck;
	positionOptions: TooltipPosition[] = [ 'after', 'before', 'above', 'below', 'left', 'right' ];
	position = new FormControl(this.positionOptions[0]);
	totalCount: number = 0;
	currentPage: number = 1;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	InvoiceStatus = InvoiceStatus;
	userStatusIcon = UserStatus;
	orderStatus = EquipmentOrderStatus;
	crStatus = ChangeRequestIndicator;
	subscriptionType = SubscriptionType;

	myQuoteStatus = MyQuoteStatus;
	pager: KngGridPager = {
		totalPages: 1,
		currentPage: this.currentPage,
		endIndex: 0,
		endPage: 1,
		pageSize: 50,
		startIndex: 0,
		startPage: 1,
		totalItems: this.state?.pageInfo?.totalCount
	};
	headerValues: KngValueListState[] = [];
	nonheaderValues: KngValueListState[] = [];
	sortingtext: string = '';
	actionLabelConstants = ActionLabel;
	@Input() checkboxState: boolean = false;
	@Output() tooltipClicked: EventEmitter<{ id: string; tooltipContent: TooltipContent; columnIndex: number; rowIndex: number }> = new EventEmitter<{ id: string; tooltipContent: TooltipContent; columnIndex: number; rowIndex: number }>();
	@Input() set state(value: KngCardListState)
	{
		this.service.updateState(value);
		this.onResize();
		this.pager = this.pagerService.getPager(
			this.state?.pageInfo?.totalCount,
			this.currentPage,
			this.state?.pageInfo?.pageSize
		);
	}

	get state(): KngCardListState
	{
		return this.service.state;
	}

	@Input() resetPage: number = 1;
	@Input() isCheckBoxRequired: boolean = false;
 	@ViewChild('cardListTable', { read: ElementRef }) tableInput!: ElementRef;
	@Output() linkToRedirection: EventEmitter<RedirectRoute> = new EventEmitter<RedirectRoute>();
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	@Output() downloadInvoice: EventEmitter<any> = new EventEmitter<any>();
	@Output() linkToQuotesPDF: EventEmitter<RedirectRoute> = new EventEmitter<RedirectRoute>();
	@Output() pageIndex: EventEmitter<number> = new EventEmitter<number>();
	@Output() stateChanged: EventEmitter<KngCardListState> = new EventEmitter<KngCardListState>();
	@Output() buttonAction: EventEmitter<TableButtonAction> = new EventEmitter<TableButtonAction>();
	@Output() sortColumnEvent: EventEmitter<KngHeaderObjState> = new EventEmitter<KngHeaderObjState>();
	@Output() userListStatus: EventEmitter<StatusChangeOptionList> = new EventEmitter<StatusChangeOptionList>();
	@Output() checkboxClickedEvent: EventEmitter<CheckboxChangeEvent> = new EventEmitter<CheckboxChangeEvent>();
	@Output() headerCheckboxClickedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
	constructor(private service: KngCardListService, private pagerService: PagerService)
	{
		this.screenWidth = window.innerWidth;
	}

	ngOnInit(): void
	{
		this.initSubscriptions();
		this.isRaymond = isRaymond || false;
		this.accordionIcon = this.state.cardListAccordionIcon?.url;
		this.arrowIconGray = this.state.cardListGrayIcon?.url;
		this.arrowIconOrange = this.state.cardListOrangeIcon?.url;
		this.totalCount = this.state?.pageInfo.totalCount;
		if (!this.state.activeIndex)
			this.state.activeIndex = -1;
		if (this.state.header.length > 0 && this.state.header[0].label === 'Service Date')
			this.state.activeIndex = 0;
	}
	ngOnChanges(changes: SimpleChanges): void
	{
		if (changes['resetPage'] && changes['resetPage'].currentValue !== changes['resetPage'].previousValue)
			this.setPage(1);
	}
	ngOnDestroy(): void
	{
		this.destroySubscriptions();
	}
	public capitalize(value: string): string
	{
		if(isRaymond)
		{
			if (/^([A-Z][\w&\/\-\.]*\s)+[A-Z][\w&\/\-\.]*$/.test(value.trim()))
			{
				return value;
			}
		}
		const capitalizeWord = value.split(/(?=[A-Z])/).map((p) =>
		{

			return p[0]?.toUpperCase() + p.slice(1);
		}).filter(el => el.length > 1).join(' ');
		return capitalizeWord || value;
	}
	private initSubscriptions(): void
	{
		const stateChangeSubs: Subscription = this.service.stateChanged.subscribe((next: KngCardListState) => this.stateChanged.emit(next));
		this.subscriptions.add(stateChangeSubs);
	}
	private destroySubscriptions(): void
	{
		this.subscriptions.unsubscribe();
	}
	public openCollapseAccordion(listIndex: number)
	{
		this.dataList[listIndex].collapsed = !this.dataList[listIndex].collapsed;
	}
	private sortNonHeaderValue(nonheaderValues: KngValueListState[]): KngValueListState[]
	{
		nonheaderValues.sort((x, y) =>
		{
			if (x.icon !== '')
				return -1;
			return y.icon !== '' ? 1 : 0;
		});
		return nonheaderValues;
	}
	handleItemCheckBoxChange(item: KngValueObjState, isChecked: boolean, index: number)
	{
		this.checkboxClickedEvent.emit({ item, isChecked, index });
	}
	handleHeaderCheckboxChange(isChecked: boolean)
	{
		this.checkboxState = isChecked;
		this.headerCheckboxClickedEvent.emit(isChecked);
	}
	private capitalizeNonHeaderValue(value: KngValueListState): void
	{
		const labelMappings: Record<string, string> = {
			equipmentVin: 'Equipment VIN',
			equipmentType: 'Equipment Classification',
			telematicsStatus: 'telematicsStatus',
			totalImpact: 'Total Impact Detection',
			batteryStateOfCharge: 'Battery %'
		};

		if (this.state.view === ScreenView.tableDesktop || this.state.view === ScreenView.tableMobile || (this.isRaymond && this.state.view === ScreenView.accordionMobile))
		{
			value.label = labelMappings[value.label] || this.capitalize(value.label);
		}
		this.nonheaderValues.push(value);
	}
	private diffHeaderNonHeaderLabel(value: KngValueListState): void
	{
		let headerFlag = false;
		this.headerList.forEach((header) =>
		{
			if (header && header.label === value.label)
			{
				this.headerValues.push(value);
				headerFlag = true;
			}
		});

		if (!headerFlag)
			this.capitalizeNonHeaderValue(value);
	}

	public createHeaderLabelMap(): void
	{
		if (this.headerList.length > 0 && this.dataList.length > 0)
		{
			for (const dataValue of this.dataList)
			{
				const listEntry = dataValue;
				this.headerValues = [];
				this.nonheaderValues = [];
				listEntry.values.forEach((value) =>
				{
					this.diffHeaderNonHeaderLabel(value);
				});
				if (this.state.view === ScreenView.tableMobile || this.state.view === ScreenView.accordionMobile)
				{
					this.nonheaderValues = this.sortNonHeaderValue(this.nonheaderValues);
				}
				const rearrangedValArr = this.headerValues.concat(this.nonheaderValues);
				dataValue.values = rearrangedValArr;
			}
		}
	}
	public removeActionBtn()
	{
		if (this.state.view === ScreenView.tableDesktop || this.state.view === ScreenView.tableMobile)
		{
			this.dataList.forEach((data) =>
			{
				data.values = data.values.filter((item) => item.category !== FieldType.action);
			});
		}
	}
	public getMobileHeaderCount(): number
	{
		let headerCount = 2;
		if (this.state.view === ScreenView.tableDesktop || this.state.view === ScreenView.tableMobile)
		{
			this.indicatorFlag = false;
			this.state.header?.forEach((data) =>
			{
				if (data.category?.includes(FieldType.indicator))
					this.indicatorFlag = true;
			});
			if (this.indicatorFlag)
				headerCount = 3;
		}
		return headerCount;
	}
	public updateHeaderStructure(deviceSupport: string): void
	{
		this.headerList = [];
		this.dataList = [];
		let headerCount = 0;
		this.dataList = JSON.parse(JSON.stringify(this.state.list));
		if (deviceSupport === ScreenView.desktop)
		{
			this.headerList = this.state?.header;
			if (this.state.view === ScreenView.accordionDeskTop)
				this.createHeaderLabelMap();
		}
		else if (deviceSupport === ScreenView.mobile)
		{
			headerCount = this.getMobileHeaderCount();
			for (let index = 0; index < headerCount; index++)
			{
				const element = this.state?.header[index];
				this.headerList.push(element);
			}
			this.createHeaderLabelMap();
			this.removeActionBtn();
		}
	}
	@HostListener('window:resize', ['$event'])
	onResize()
	{
		this.screenWidth = window.innerWidth;
		if (this.screenWidth >= 768)
		{
			if (this.state.view === ScreenView.tableMobile)
				this.state.view = ScreenView.tableDesktop;
			this.updateHeaderStructure(ScreenView.desktop);
		}
		else if (this.screenWidth < 768)
		{
			if (this.state.view === ScreenView.tableDesktop)
				this.state.view = ScreenView.tableMobile;
			this.updateHeaderStructure(ScreenView.mobile);
		}
	}
	sortColumn(value: KngHeaderObjState, index: number)
	{
		this.state.activeIndex = index;
		if (this.state.list.length > 0)
		{
			this.checkSortOrder(value);
			this.sortColumnEvent.emit(value);
		}
	}
	sortColumnByKey(event: KeyboardEvent, value: KngHeaderObjState, index: number)
	{
		if (event.key === KeyEvent.tab)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		this.checkSortOrder(value);
		if (event.key === KeyEvent.enter)
			this.sortColumn(value, index);
	}
	checkSortOrder(value: KngHeaderObjState)
	{
		if (value.sortOrder === SortOrder.asc)
		{
			value.sortOrder = SortOrder.desc;
			this.sortingtext = 'descending';
		}
		else
		{
			value.sortOrder = SortOrder.asc;
			this.sortingtext = 'ascending';
		}
	}
	setPage(e: number)
	{
		this.pageNumber = e;
		if (e < 1 || e > this.pager.totalPages)
			return;
		else
			this.pager.currentPage = e;
		this.pageIndex.emit(e - 1);
		this.currentPage = e;
		this.pager = this.pagerService.getPager(this.state?.pageInfo?.totalCount, e, this.state?.pageInfo?.pageSize);
	}
	pageClick()
	{
		setTimeout(() => this.tableInput.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
	}
	onActionClick(category: KngValueObjState, action: ActionOpsList): void
	{
		const actionEve = { category: category, action: action };
		this.buttonAction.emit(actionEve);
	}
	public convertStringToNumber(data: AllDataType): number | string
	{
		return data !== '' ? Number(data) : '';
	}
	public convertStringToDate(data: AllDataType): Date | string
	{
		return data && typeof (data) !== 'boolean' ? new Date(data) : '';
	}
	public useDisplayType(data: KngValueListState): string | number | boolean
	{
		let displayValue = data.labelValue;
		if (data.displayType && data.labelValue!== '—')
		{

			const values = data.labelValue.toString().split(data.displayType.separator);

			if (data.displayType.styleChange && data.displayType.styleChange === 'beforeSeparatorBold')
			{
				displayValue = `<strong>${values[0]}</strong><br>${values[1]}`;
			}

		}
		return displayValue;
	}
 	updateStatus(statusItems: StatusChangeOptionList)
	{
		this.userListStatus.emit(statusItems);
	}
	public linkToRedirectionEquipment(fieldValue: FieldValueType, fieldLabel: string, userId?: string, customerId?: string, orderId?: string, locationId?: string)
	{
		if (this.fieldValueCheck(fieldValue))
		{
			if (userId)
				this.linkToRedirection.emit({ label: fieldLabel, value: fieldValue, userId: userId });
			else if (customerId)
				this.linkToRedirection.emit({ label: fieldLabel, value: fieldValue, customerId: customerId });
			else if (orderId)
				this.linkToRedirection.emit({ label: fieldLabel, value: fieldValue, orderId: orderId });
			else if (locationId)
				this.linkToRedirection.emit({ label: fieldLabel, value: fieldValue, locationId: locationId });
			else
				this.linkToRedirection.emit({ label: fieldLabel, value: fieldValue });
		}
	}

	fieldValueCheck(value: FieldValueType): FieldValueType
	{
		return value && value !== NullCheck.nullValue;
	}

	public linktoDownloadPDF(fieldValue: FieldValueType, fieldLabel: string, documentURL?: string)
	{
		if (fieldValue && fieldValue !== NullCheck.nullValue)
		{
			if (documentURL)
				this.linkToQuotesPDF.emit({ label: fieldLabel, value: fieldValue, documentURL: documentURL });
		}
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public downloadInvoicePDF(fieldValue:any)
	{
		if (fieldValue && fieldValue !== NullCheck.nullValue)
		{
			this.downloadInvoice.emit(fieldValue);
		}
	}
	public isTelematicsStatus(value: AllDataType): boolean
	{
		if (value && value === TelematicsStatus.connected)
		{
			this.isTelematicsResponse.connected = true;
			this.isTelematicsResponse.notConnected = false;
			this.isTelematicsResponse.error = false;
			return this.isTelematicsResponse.connected;
		}
		else if (value && value === TelematicsStatus.notConnected)
		{
			this.isTelematicsResponse.notConnected = true;
			this.isTelematicsResponse.connected = false;
			this.isTelematicsResponse.error = false;
			return !this.isTelematicsResponse.notConnected;
		}
		else
		{
			this.isTelematicsResponse.error = true;
			this.isTelematicsResponse.connected = false;
			this.isTelematicsResponse.notConnected = false;
			return this.isTelematicsResponse.error;
		}
	}
	public getTelematicsTooltipValue(value : AllDataType): string
	{
		switch (value)
		{
		case TelematicsStatus.connected:
			return 'Connected';
		case TelematicsStatus.active:
			return 'Connected';
		case TelematicsStatus.notConnected:
			return 'No Device';
		default:
			return '';
		}
	}
	showTooltip(id: string | undefined, tooltipContent: TooltipContent | undefined, columnIndex: number, rowIndex: number)
	{
		this.tooltipClicked.emit({ id: id ?? '', tooltipContent: tooltipContent ?? { closeIcon: { iconPath: '', altText: '' }, content: '' }, columnIndex: columnIndex, rowIndex: rowIndex });
	}
	updatePendingOrErrorState(rowIndex: number, columnIndex: number, record: KngValueListState)
	{
		this.dataList[rowIndex].values[columnIndex].isError = record.isError;
		this.dataList[rowIndex].values[columnIndex].errorIcon = record.errorIcon;
		this.dataList[rowIndex].values[columnIndex].tooltip = record.tooltip;
		this.dataList[rowIndex].values[columnIndex].isStatusUpdatePending = record.isStatusUpdatePending;
		this.dataList[rowIndex].values[columnIndex].statusUpdatePendingMessage = record.statusUpdatePendingMessage;
		this.dataList[rowIndex].values[columnIndex].labelValue = record.labelValue;
	}

	removeTooltipSeparator(value: string | number | boolean)
	{
		return value.toString().replace('~', '');
	}

	getOrderStatusClass(value: string | number | boolean)
	{
		switch(value)
		{
		case this.orderStatus.orderInProcess:
			return OrderClassList.orderInProcess;

		case this.orderStatus.inProduction:
			return OrderClassList.inProduction;

		case this.orderStatus.shipped:
			return OrderClassList.shipped;

		case this.orderStatus.delivered:
			return OrderClassList.delivered;

		case this.orderStatus.cancelled:
			return OrderClassList.cancelled;
		default: return '';
		}
	}

	getSubscriptionStatusClass(value : string | number | boolean)
	{
		switch(value)
		{
		case this.subscriptionType.noSubscription:
			return SubscriptionClassList.nosub;

		case this.subscriptionType.myinsightscompliance:
			return SubscriptionClassList.myInsightCompliance;

		case this.subscriptionType.myinsights:
			return OrderClassList.orderInProcess;

		default:
			return '';
		}
	}

	modifyTooltipContent()
	{
		const observer = new MutationObserver(()=>
		{
			const tooltip  = document.querySelector('.subscription-table-header');
			if(tooltip)
			{
				tooltip.innerHTML = tooltip.innerHTML.replace(/Invoice on/, '<b>Invoice on</b>');
				tooltip.innerHTML = tooltip.innerHTML.replace(/Renewal on/, '<br><b>Renewal on</b>');
				tooltip.innerHTML = tooltip.innerHTML.replace(/Ends on/, '<br><b>Ends on</B>');
			}
			observer.disconnect();
		});
		observer.observe(document.body, { childList: true, subtree: true } );

		setTimeout(()=> observer.disconnect(), 1000 );
	}

	checkValueCategory(category: string | undefined)
	{
		let isValueExist = false;
		const valueList: string[] = [ FieldType.text, FieldType.restrictedLink, FieldType.primaryText, FieldType.invoice, FieldType.address, FieldType.subscription, FieldType.equipmentAddress, FieldType.primarySubLocation, FieldType.subscriptionTerm ];
		if(category)
		{
			isValueExist = valueList.includes(category)? true: false;
		}
		return isValueExist;
	}
}
